"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Root = exports.classes = void 0;
const styles_1 = require("@mui/material/styles");
const PREFIX = "CardInput";
exports.classes = {
    input: `${PREFIX}-input`,
    card: `${PREFIX}-card`
};
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    display: "block",
    height: "100%",
    [`& .${exports.classes.input}:checked + .${exports.classes.card}`]: {
        padding: "0px",
        border: `2px solid ${theme.colours.accent}`
    },
    [`& .${exports.classes.input}`]: {
        position: "absolute",
        clip: "rect(0 0 0 0)"
    },
    [`& .${exports.classes.card}`]: {
        padding: "2px",
        height: "100%"
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2NhcmQtaW5wdXQvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGlEQUE4QztBQUU5QyxNQUFNLE1BQU0sR0FBRyxXQUFXLENBQUM7QUFFZCxRQUFBLE9BQU8sR0FBRztJQUNyQixLQUFLLEVBQUUsR0FBRyxNQUFNLFFBQVE7SUFDeEIsSUFBSSxFQUFFLEdBQUcsTUFBTSxPQUFPO0NBQ3ZCLENBQUM7QUFFVyxRQUFBLElBQUksR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQyxDQUFDLEVBQUUsS0FBSyxFQUFFLEVBQUUsRUFBRSxDQUFDLENBQUM7SUFDaEQsT0FBTyxFQUFFLE9BQU87SUFDaEIsTUFBTSxFQUFFLE1BQU07SUFDZCxDQUFDLE1BQU0sZUFBTyxDQUFDLEtBQUssZUFBZSxlQUFPLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUNsRCxPQUFPLEVBQUUsS0FBSztRQUNkLE1BQU0sRUFBRSxhQUFhLEtBQUssQ0FBQyxPQUFPLENBQUMsTUFBTSxFQUFFO0tBQzVDO0lBQ0QsQ0FBQyxNQUFNLGVBQU8sQ0FBQyxLQUFLLEVBQUUsQ0FBQyxFQUFFO1FBQ3ZCLFFBQVEsRUFBRSxVQUFVO1FBQ3BCLElBQUksRUFBRSxlQUFlO0tBQ3RCO0lBQ0QsQ0FBQyxNQUFNLGVBQU8sQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQ3RCLE9BQU8sRUFBRSxLQUFLO1FBQ2QsTUFBTSxFQUFFLE1BQU07S0FDZjtDQUNGLENBQUMsQ0FBQyxDQUFDIn0=